import React from "react";
import { Calendar } from "react-calendar"; // Install react-calendar package

const CalendarView = () => {
  const handleDateChange = (date) => {
    console.log(date);
  };

  return (
    <div>
      <h2>Calendar</h2>
      <Calendar onChange={handleDateChange} />
    </div>
  );
};

export default CalendarView;
